interface PromptSuggestionsProps {
  label: string
  append: (message: { role: "user"; content: string }) => void
  suggestions: string[]
}

export function PromptSuggestions({ label, append, suggestions }: PromptSuggestionsProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-center text-xl">{label}</h2>
      <div className="flex flex-col items-center justify-around gap-2 text-sm md:flex-row md:items-stretch md:gap-6">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => append({ role: "user", content: suggestion })}
            className="flex max-w-[90%] flex-grow flex-col items-center justify-center gap-2 rounded-xl border bg-background p-4 hover:bg-muted md:flex-1"
          >
            <p>{suggestion}</p>
          </button>
        ))}
      </div>
    </div>
  )
}
